'use client'
import type { FC, MouseEvent } from 'react'
import { Text } from '@chakra-ui/react'
import Link from 'next/link'

export interface MenuItem {
  id: string
  text: string
  path: string
  isCurrent?: boolean
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
  other?: any[]
  onHoverEnter?: () => void
  onHoverLeave?: () => void
  isDarkBackground?: boolean
}

export const MenuItemComponent: FC<MenuItem> = ({ text, path, isCurrent, onClick }) => {
  return (
    <Link href={path} onClick={onClick}>
      <Text
        fontSize="0.95rem"
        fontWeight={500}
        color={isCurrent ? 'text.default' : 'text.secondary'}
        transition="color 0.2s ease"
        _hover={{ color: 'text.default' }}
      >
        {text}
      </Text>
    </Link>
  )
}
